import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
// import AddCarnivalPopup from "./addCarnivalPopup";

const FdTicketsListing = ({ 
    fetchfdTicketList = null, 
    fdTicketLists = null, 
    match,
    history
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentCarnivalStatus, setCurrentcarnivalStatus] = useState('');
  const [carnivalId, setCarnivalId] = useState('');
  const [changeStatus, setChangeStatus] = useState(false);
  const [projectId, setProjectId] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);


  const Headers = [
    'FreshDesk Id',
    'Created By',
    'Subject',
    'Priority',
    'Category',
    'Status',
    'Actions',
  ];

  useEffect(() => {
    if (fetchfdTicketList !== null)
      (async () => {
        setIsLoading(true);
        await fetchfdTicketList();
        setIsLoading(false);
      })();
  }, [fetchfdTicketList]);

  useEffect(() => {
    const tableData = [
      'id',
      'freshdesk_id',
      'name',
      'subject',
      'priority',
      'category',
      'status',
    ];
    const data =
    fdTicketLists?.resultSets?.length &&
    fdTicketLists.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
            {
              Action:
                [{
                  name: 'View Details',
                  link: `${baseUrl}/view-fd-ticket`,
                }]
            }
        )
      );
      // console.log(tableData);
    if (fdTicketLists?.resultSets?.length && data) {
      setListData(data);
      setPageCount(Math.ceil(fdTicketLists.total / fdTicketLists.per_page));
    } else {
      setListData([]);
    }
  }, [fdTicketLists, baseUrl]);

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setPageNumber(val.selected + 1);
    setIsLoading(true);
    await fetchfdTicketList(filter, val.selected + 1);
    setIsLoading(false);
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    // console.log(filterData);return;
    setIsLoading(true);
    setFilterData(filterData);
    await fetchfdTicketList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };
  

  const headerBtns = () => {
    return (
      <Fragment>
        {/* <Link
          to={{
            pathname: `${baseUrl}/brand-activation/fd-tickets/create`,
            query: { noOfCamp: fetchfdTicketList?.resultSets?.length },
          }}
          className="btn btn-primary d-md-inline-block"
        >
          {localization.createTickets}
          <img src={Images?.ArrowRight} alt="" />
        </Link> */}
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
        >
          <img src={Images?.Filter} alt="" />
          <b className="site_filters" style={{width:"max-content"}}>
          {localization.showFilters}
          </b>
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.freshdeskTickets}
      Buttons={headerBtns}
      isLoading={isLoading}
      linkFlag
    >
      <TableSection
        data={listData}
        headers={Headers}
        detailList={fdTicketLists?.resultSets}
        isId={false}
        pageCount={pageCount}
        onPageChange={onPageChange}
        srNo={fdTicketLists?.from}
      />


      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        fdFilters={true}
      />
    </Layout>
  );
}; 

FdTicketsListing.propTypes = {
    fdTicketLists: PropTypes.any,
    fetchfdTicketList: PropTypes.func,
    match: PropTypes.any,
};

export default FdTicketsListing;
